/**
 * LocaleTabSwitcher — ES / EN / PT locale tab buttons.
 *
 * Props:
 * - locale: 'es' | 'en' | 'pt'  — currently active locale
 * - onChange: (locale: 'es' | 'en' | 'pt') => void
 */

export type SupportedLocale = 'es' | 'en' | 'pt'

const LOCALES: { value: SupportedLocale; label: string }[] = [
  { value: 'es', label: 'ES' },
  { value: 'en', label: 'EN' },
  { value: 'pt', label: 'PT' },
]

interface LocaleTabSwitcherProps {
  locale: SupportedLocale
  onChange: (locale: SupportedLocale) => void
}

export function LocaleTabSwitcher({ locale, onChange }: LocaleTabSwitcherProps) {
  return (
    <div className="flex gap-1">
      {LOCALES.map(({ value, label }) => (
        <button
          key={value}
          type="button"
          onClick={() => onChange(value)}
          className={[
            'px-4 py-1.5 text-sm font-medium rounded transition-colors border',
            locale === value
              ? 'bg-blue-600 text-white border-blue-600'
              : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50',
          ].join(' ')}
        >
          {label}
        </button>
      ))}
    </div>
  )
}
